import React from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import { injectGlobal } from '@emotion/css';
import { ReactiveBase } from '@appbaseio/reactivesearch';
import Footer from 'marketplace-footer';
import 'marketplace-footer/build/static/css/index.css';
import { APP, CRED, URL } from './constants';

import Home from './pages/Home';
import Book from './pages/Book';
import Search from './pages/Search';

// eslint-disable-next-line
injectGlobal`
* {
    margin: 0;
	font-family: "Open Sans", "Lato", "Montserrat", "Muli", sans-serif;
  }
`;

/*
	This is where we define the Routing.
	ReactiveBase is a container component that wraps all the ReactiveSearch components together

	For URL / we render Home Component i.e. Home Page.
	For URL /search we render Search Component i.e. Search Page.
	For URL /book/:id we render Book Component i.e. Book Detail Page - We will get :id in props.match.params.

	Last Route i.e. L36 can be use to define Not Found Page for now we are just displaying Home page.
*/

const App = () => (
	<ReactiveBase app={APP} credentials={CRED} url={URL} enableAppbase>
		<Router>
			<Switch>
				<Route exact path="/" component={Home} />
				<Route exact path="/search" component={Search} />
				<Route exact path="/book/:id" component={Book} />
				<Route component={Home} />
			</Switch>
		</Router>
		<Footer price="$99" url="https://gumroad.com/l/CVWBZ" />
	</ReactiveBase>
);

export default App;
